<div class="sidebar-reference-question-set"><app-loading [isLoading]="isLoading"><app-sidebar-reference-question-set-alerts [reference]="reference"></app-sidebar-reference-question-set-alerts><app-card [isHeaderLeft]="!!reference.score">
<div class="app-card-left"><app-score [score]="reference.score" [radius]="45" [titleFontSize]="20"></app-score></div>
<div class="app-card-right">
  <div class="row">
    <div class="col-12 col-md-6">
      <h3 class="h4">{{ reference.full_name }}@if (isCompleting) {
        <i class="lnr lnr-bubble-pencil ms-2 fadeIn v-text-primary" aria-hidden="true" [tooltip]="'COMMON.IS_COMPLETING' | translate" container="body"></i>
      }</h3>
      <div class="text-muted small">{{ getRelationshipComplete(reference.relationship) }}</div>
      @if (reference.title) {
        <div class="text-muted small"><i class="lnr lnr-briefcase me-2" aria-hidden="true"></i>{{ reference.title }}</div>
      }
    </div>
    <div class="col-12 col-md-6">
      <div class="btn-toolbar float-end mb-2"><button class="btn btn-light me-2 mb-4" type="button" (click)="getReference(true)" [tooltip]="'BUTTONS.REFRESH' | translate : { type : 'reference' }" container="body"><i class="lnr lnr-refresh" aria-hidden="true"></i></button>@if (isEditable) {
      <button class="btn btn-light me-2 mb-4" type="button" (click)="openModal()" [tooltip]="'BUTTONS.EDIT' | translate : { type : 'reference' }" container="body"><i class="lnr lnr-pencil" aria-hidden="true"></i></button>
      }<button class="btn btn-outline-danger me-2 mb-4" type="button" (click)="openDeleteModal()" container="body"><span>{{ 'BUTTONS.DEACTIVATE' | translate }}</span></button>@if (canPurgeData) {
      <button class="btn v-btn-danger me-2 mb-4" type="button" (click)="openAnonymizeModal()" container="body"><span>{{ 'BUTTONS.PURGE_DATA' | translate }}</span></button>
    }
    @if (isDownloadable) {
      <div class="btn-group"><button class="btn btn-light" type="button" (click)="includeReportContact = !includeReportContact" [disabled]="isDownloading" [tooltip]="'BUTTONS.SHOW_CANDIDATE' | translate" container="body"><i class="lnr lnr-eye" aria-hidden="true" [ngClass]="{ 'v-text-primary': includeReportContact }"></i></button>@if (!settings?.is_docx_enabled) {
      <button class="btn v-btn-primary" type="button" (click)="download()" [disabled]="isDownloading" [tooltip]="'BUTTONS.DOWNLOAD' | translate : { type: 'report' }" container="body" [appEventTracker]="{ label: 'download_reference_report', category: 'buttons' }"><i [ngClass]="{'fa fa-spinner fa-spin': isDownloading, 'lnr lnr-download2': !isDownloading}" aria-hidden="true"></i></button>
    }
    @if (settings?.is_docx_enabled) {
      <div class="btn-group" dropdown="dropdown" placement="bottom right" [isDisabled]="isDownloading"><button class="btn v-btn-primary dropdown-toggle" type="button" dropdownToggle="dropdownToggle" [tooltip]="'BUTTONS.DOWNLOAD' | translate : { type: 'report' }" container="body"><i [ngClass]="{'fa fa-spinner fa-spin': isDownloading, 'lnr lnr-download2': !isDownloading }" aria-hidden="true"></i></button>
      <ul class="dropdown-menu dropdown-menu-right" role="menu" *dropdownMenu="">
        @for (f of reportFormats; track f) {
          <li role="menuitem">
            <div class="dropdown-item" (click)="download(f.id)" [appEventTracker]="{ label: 'download_reference_report' + f.id, category: 'buttons' }" [innerHTML]="'BUTTONS.DOWNLOAD' | translate : { type: f.label }"></div>
          </li>
        }
      </ul>
    </div>
  }
</div>
}
</div>
@if (isReferenceSyncAvailable) {
  <div class="row">
    <div class="col-12">
      <div class="btn-toolbar float-end">
        <div class="btn-group" dropdown="dropdown" placement="bottom right" [isDisabled]="isSynchronizing"><button class="btn v-btn-primary dropdown-toggle" type="button" dropdownToggle="dropdownToggle">{{ 'BUTTONS.SYNCHRONIZE.BUTTON' | translate }}</button>
        <ul class="dropdown-menu dropdown-menu-right" role="menu" *dropdownMenu="">@for (e of externalAuthorizations; track e) {
          @if (e.isAuthorized) {
            <li role="menuitem">
              <div class="dropdown-item" (click)="uploadReference(e.id)" [innerHTML]="'BUTTONS.SYNCHRONIZE.DETAILS' | translate : e"></div>
            </li>
          }
          @if (e.isAuthorized) {
            <li role="menuitem">
              <div class="dropdown-item" (click)="uploadDocument(e.id)" [innerHTML]="'BUTTONS.UPLOAD.DETAILS' | translate : e"></div>
            </li>
          }
        }</ul>
      </div>
    </div>
  </div>
</div>
}
</div>
</div>
<div class="row mt-4">
  <div class="col-12">
    <ul class="list-unstyled">
      <li>@if (!reference.email) {
        <i class="small text-muted lnr lnr-envelope me-2" aria-hidden="true"></i><span class="small text-muted">-</span>
      }
      @if (reference.hasEmailWarning) {
        <div class="small text-muted"><i class="lnr me-2" aria-hidden="true" [ngClass]="reference.email_validity.class" [tooltip]="reference.email_validity.tooltip" container="body"></i>{{ reference.email_validity.label }}</div>
        }@if (reference.email && !reference.hasEmailWarning) {
        <a class="small" [href]="'mailto:' + reference.email"><i class="lnr me-2" aria-hidden="true" [ngClass]="reference.email_validity.class" [tooltip]="reference.email_validity.tooltip" container="body"></i>{{ reference.email_validity.label }}</a>
      }
    </li>
    <li>
      @if (!reference.phone || reference.hasPhoneNumberWarning) {
        <div class="small"><i class="lnr me-2" aria-hidden="true" [tooltip]="reference.phone_number_validity.tooltip" container="body" [ngClass]="reference.phone_number_validity.class"></i><span class="text-muted">{{ reference.phone_number_validity.label }}</span></div>
        }@if (reference.phone && !reference.hasPhoneNumberWarning) {
        <a class="small" [href]="'tel:' + reference.phone_number"><i class="lnr me-2" aria-hidden="true" [tooltip]="reference.phone_number_validity.tooltip" container="body" [ngClass]="reference.phone_number_validity.class"></i>{{ reference.phone_number_validity.label }}</a>
      }
    </li>
    @if (reference.work_phone) {
      <li><a class="small" [href]="'tel:' + reference.work_phone_number"><i class="lnr lnr-smartphone text-muted me-2" aria-hidden="true"></i>{{ reference.work_phone_number_with_extension }}</a></li>
    }
  </ul>
</div>
<div class="col-12 text-end">
  <div class="text-muted small">{{ reference?.question_set?.title }}</div>
  <div class="text-muted small">{{ reference.filled_at | dateFormat : 'MMM DD, YYYY hh:mma' }}</div>
  <div class="small">{{ reference.notes }}</div>
</div>
@if (hasReferenceEdits) {
  <div class="col-12 text-end mt-2"><button class="btn btn-outline-primary v-btn-outline-primary btn-sm" type="button" data-testid="reference-edits-toggle" [attr.aria-expanded]="isReferenceEditsOpen" [attr.aria-label]="(isReferenceEditsOpen ? 'REFERENCE.EDITS.HIDE' : 'REFERENCE.EDITS.SHOW_WITH_COUNT') | translate : { count: referenceEditsCount }" (click)="toggleReferenceEdits()">@if (!isReferenceEditsOpen) {
    <span>{{ 'REFERENCE.EDITS.SHOW_WITH_COUNT' | translate : { count: referenceEditsCount } }}</span>
    }@if (isReferenceEditsOpen) {
    <span>{{ 'REFERENCE.EDITS.HIDE' | translate }}</span>
  }</button></div>
}
</div>
</div>
</app-card>@if (isReferenceEditsOpen) {
<app-sidebar-reference-question-set-edits-card [reference]="reference"></app-sidebar-reference-question-set-edits-card>
}
@if (!reference?.decline) {
  <div class="pt-4"><app-answers [title]="title" [answers]="answers" [afterSubmit]="afterSubmit"></app-answers></div>
  }<app-modals-references [openModal]="openReferenceModal" [afterSubmit]="afterSubmit" [isQSEditable]="!reference.filled_at"></app-modals-references><app-modals [title]="'REFERENCE.CONFIRM.TITLE'" [openModal]="openConfirmModal" [closeModal]="closeModal" [whenModalClose]="delete" [deleteKey]="'BUTTONS.DELETE' | translate" [isButtonsDisabled]="isButtonsDisabled">
  <p [innerHTML]="'REFERENCE.CONFIRM.DESCRIPTION' | translate : { fullName: $safeNavigationMigration(reference?.full_name) }"></p>
  </app-modals><app-modals-reference-notification [openModal]="openNotificationModal"></app-modals-reference-notification><app-modals [title]="'REFERENCE.ANONYMIZE.TITLE' | translate" [openModal]="openAnonymizeConfirmModal" [closeModal]="closeModal" [whenModalClose]="anonymize" [deleteKey]="'BUTTONS.PURGE_DATA' | translate" [isButtonsDisabled]="isButtonsDisabled">
  <p [innerHTML]="'REFERENCE.ANONYMIZE.DESCRIPTION' | translate : { fullName: $safeNavigationMigration(reference?.full_name) }"></p>
</app-modals>
</app-loading></div>
